import React from 'react';
import {
  ClipboardCheck,
  Bullseye,
  LightningCharge,
  PersonCheck,
  ShieldCheck,
  Telephone,
  Whatsapp
} from 'react-bootstrap-icons';
import './App.css';
import './Landing.css';
import NavBar from './NavBar';
import ContactForm from './ContactForm';
import WorksCarousel from './WorksCarousel';
import logo from './images/logo.jpg';
import heroProject from './images/projects/hativat-hanegev-1.webp';

const services = [
  {
    title: 'תכנון וייעוץ חשמל',
    text: 'תכנון מערכות חשמל, תאורה ותקשורת בהתאמה לצורכי הפרויקט ולדרישות התקן.',
    icon: LightningCharge
  },
  {
    title: 'סקרי קרינה',
    text: 'ביצוע בדיקות וסקרי קרינה באמצעות ציוד מקצועי, לצורך בדיקה וקבלת היתרים.',
    icon: Bullseye
  },
  {
    title: 'פיקוח וליווי פרויקטים',
    text: 'ליווי מקצועי ותיאום מול גורמי חוץ משלב התכנון ועד למסירת הפרויקט.',
    icon: ClipboardCheck
  }
];

const trustItems = [
  {
    title: 'דיוק הנדסי',
    text: 'תכנון מוקפד ופתרונות מעשיים',
    icon: Bullseye
  },
  {
    title: 'בטיחות קודמת לכל',
    text: 'עבודה בהתאם לדרישות ולתקנים',
    icon: ShieldCheck
  },
  {
    title: 'ליווי מקצועי',
    text: 'זמינות ושיתוף פעולה לאורך הדרך',
    icon: PersonCheck
  }
];

function App() {
  return (
    <div className="site" dir="rtl">
      <NavBar />

      <main>
        <section id="top" className="hero" aria-labelledby="hero-title">
          <div className="hero-copy">
            <p className="eyebrow">Eligman Engineering Solutions LTD</p>
            <h1 id="hero-title">תכנון, ייעוץ ופיקוח למערכות חשמל, תאורה ותקשורת</h1>
            <p className="hero-lead">
              פתרונות הנדסיים מקצועיים משלב התכנון ועד למסירה, עם דגש על בטיחות,
              אמינות והתאמה מלאה לדרישות הפרויקט.
            </p>
            <div className="hero-actions" aria-label="פעולות ראשיות">
              <a className="button button-primary" href="#contact">קבלת ייעוץ</a>
              <a className="button button-secondary" href="#projects">לפרויקטים שלנו</a>
            </div>
            <a className="hero-phone" href="tel:0545995998">
              <Telephone aria-hidden="true" />
              <span>054-599-5998</span>
            </a>
          </div>

          <div className="hero-media">
            <img
              src={heroProject}
              alt="הדמיית פרויקט חטיבת הנגב 22 באשדוד"
              width="1600"
              height="900"
              loading="eager"
              decoding="async"
              fetchpriority="high"
            />
            <div className="hero-project-label">
              <span>פרויקט נבחר</span>
              <strong>חטיבת הנגב 22, אשדוד</strong>
            </div>
          </div>
        </section>

        <section className="trust-band" aria-label="הערכים שלנו">
          <div className="content-width trust-grid">
            {trustItems.map(({ title, text, icon: Icon }) => (
              <article className="trust-item" key={title}>
                <Icon aria-hidden="true" />
                <div>
                  <h2>{title}</h2>
                  <p>{text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="services" className="section services-section" aria-labelledby="services-title">
          <div className="content-width">
            <header className="section-heading section-heading-centered">
              <p className="eyebrow">תחומי התמחות</p>
              <h2 id="services-title">מעטפת הנדסית מדויקת לכל פרויקט</h2>
              <p>שירות מקצועי, ברור ומלווה — מהרעיון הראשוני ועד לביצוע.</p>
            </header>

            <div className="services-grid">
              {services.map(({ title, text, icon: Icon }, index) => (
                <article className="service-item" key={title}>
                  <span className="service-number">0{index + 1}</span>
                  <Icon className="service-icon" aria-hidden="true" />
                  <h3>{title}</h3>
                  <p>{text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="about" className="section about-section" aria-labelledby="about-title">
          <div className="content-width about-layout">
            <div className="about-mark" aria-hidden="true"><img src={logo} alt="" /></div>
            <div className="about-copy">
              <p className="eyebrow">קצת עלינו</p>
              <h2 id="about-title">פתרונות הנדסיים עם ראייה רחבה</h2>
              <p>
                אליגמן פתרונות הנדסיים בע״מ נוסדה בשנת 2019 ומעניקה מענה תכנוני
                ויישומי למערכות חשמל, תקשורת ותאורה בפרויקטים מגוונים.
              </p>
              <p>
                אנו משלבים מקצועיות, עבודת צוות ועמידה בלוחות זמנים, תוך התחשבות
                בתקציב ההקמה ובעלויות התפעול והתחזוקה לאורך חיי המתקן.
              </p>
              <a className="text-link" href="#contact">בואו נדבר על הפרויקט שלכם</a>
            </div>
          </div>
        </section>

        <WorksCarousel />

        <section className="section process-section" aria-labelledby="process-title">
          <div className="content-width">
            <header className="section-heading">
              <p className="eyebrow">דרך העבודה שלנו</p>
              <h2 id="process-title">תהליך מסודר. החלטות ברורות.</h2>
            </header>
            <ol className="process-list">
              <li><span>01</span><strong>אפיון הצורך</strong><p>היכרות עם הפרויקט, הדרישות והיעדים.</p></li>
              <li><span>02</span><strong>תכנון ותיאום</strong><p>בניית פתרון הנדסי ותיאום עם הגורמים הרלוונטיים.</p></li>
              <li><span>03</span><strong>ליווי ופיקוח</strong><p>מעקב מקצועי אחר הביצוע ומתן מענה לאורך הדרך.</p></li>
              <li><span>04</span><strong>מסירה</strong><p>בדיקה סופית והשלמת הפרויקט באופן מסודר.</p></li>
            </ol>
          </div>
        </section>

        <section id="contact" className="section contact-section" aria-labelledby="contact-title">
          <ContactForm />
        </section>
      </main>

      <footer className="site-footer">
        <div className="content-width footer-layout">
          <div className="footer-brand">
            <img src={logo} alt="לוגו אליגמן פתרונות הנדסיים" />
            <div><strong>אליגמן פתרונות הנדסיים בע״מ</strong><span>חשמל · תאורה · תקשורת</span></div>
          </div>
          <nav aria-label="ניווט תחתון">
            <a href="#services">שירותים</a>
            <a href="#projects">פרויקטים</a>
            <a href="#about">אודות</a>
            <a href="#contact">צור קשר</a>
          </nav>
          <p>© {new Date().getFullYear()} כל הזכויות שמורות לאליגמן פתרונות הנדסיים בע״מ</p>
        </div>
      </footer>

      <a
        className="floating-whatsapp"
        href="https://wa.me/message/YNZRORK7GIY2P1"
        target="_blank"
        rel="noreferrer"
        aria-label="שליחת הודעה לאליגמן ב-WhatsApp"
      >
        <Whatsapp aria-hidden="true" />
        <span className="sr-only">שליחת הודעה לאליגמן ב-WhatsApp</span>
      </a>
    </div>
  );
}

export default App;
